import { render, staticRenderFns } from "./trans-loader.vue?vue&type=template&id=41107c00&scoped=true&"
import script from "./trans-loader.vue?vue&type=script&lang=js&"
export * from "./trans-loader.vue?vue&type=script&lang=js&"
import style0 from "./trans-loader.vue?vue&type=style&index=0&id=41107c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41107c00",
  null
  
)

export default component.exports